async function handleAddToCartFormSubmit(e) {
  e.preventDefault();
  const form = e.target;
  const button = form.querySelector('button[type="submit"]');

  button.classList.add('is-loading');

  const response = await fetch(form.action, {
    method: form.method,
    headers: {
      Accept: 'application/json',
      credentials: 'same-origin',
    },
    body: new FormData(form),
  });

  const { status } = await response.json();

  if (status) {
    setTimeout(() => {
      button.classList.remove('is-loading');
      button.classList.add('has-check');
      button.setAttribute('disabled', 'disabled');

      setTimeout(() => {
        window.livewire.emitTo('cart.button', 'refresh');
        button.classList.remove('has-check');
        button.removeAttribute('disabled');
      }, 2000);
    }, 500);
  }
}

function initialize() {
  const addToCartButton = document.querySelectorAll('[data-form="add-to-cart"]');

  if (addToCartButton) {
    addToCartButton.forEach(item => item.addEventListener('submit', handleAddToCartFormSubmit));
  }
}

export default initialize;



// WEBPACK FOOTER //
// ./resources/assets/js/components/cart.js